<template>
  <div class="order_payment">
    <div v-show="this.paymentGoods.length" class="order_have">
      <ul class="payment_navtop">
        <li>商品画像</li>
        <li>商品名</li>
        <li>商品単価</li>
        <li>商品数量</li>
        <li>設定</li>
      </ul>
      <div class="payment_main">
        <ul class="payment_main_goods">
          <li><span><img src="../../assets/images/goods/cart_goods_img.png"></span></li>
          <li><p><span>持续吸收性VB</span></p></li>
          <li><p><span>X2</span></p></li>
          <li><p><span>￥960</span></p></li>
          <li>
            <div class="goodsBtn">
              <button>即座に支払う</button>
              <button>注文の詳細</button>
              <button>注文を削除する</button>
            </div>
          </li>
        </ul>
        <div class="payment_main_footer">
          <span>小計：<label>￥960</label></span>
          <span>合計<label>1</label>点</span>
        </div>
      </div>
    </div>
    <div v-show="this.paymentGoods.length" class="order_Phave">
      <ul class="payment_navtop">
        <li>商品画像</li>
        <li>商品名</li>
        <li>商品数量</li>
        <li>商品単価</li>
      </ul>
      <div class="payment_main">
        <ul class="payment_main_goods">
          <li><img src="../../assets/images/goods/cart_goods_img.png"></li>
          <li><p><span>持续吸收性VB</span></p></li>
          <li><p><span>X2</span></p></li>
          <li><p><span>￥960</span></p></li>
        </ul>
        <p class="payment_main_Price">
          <span>小計：<label>￥132</label></span>
          <span>合計 <label>1</label>点</span>
        </p>
        <div class="payment_main_footer">
          <span>即座に支払う</span>
          <span>注文の詳細</span>
          <span>注文を削除する</span>
        </div>
      </div>
    </div>
    <div v-show="!this.paymentGoods.length" class="order_no">
      <img src="../../assets/images/personal/wu.png" height="315" width="175"/>
      <span>関連注文はありません。</span>
    </div>
    <div v-show="!this.paymentGoods.length" class="order_pno">
      <img src="../../assets/images/personal/wu.png" height="315" width="175"/>
      <span>関連注文はありません。</span>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
        paymentGoods: [1],
      }
    },
    methods: {
      toCartBuy(){
        this.$router.push({
          path: "/cart/buy",
        })
      },
    },
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .order_payment {
      width: 100%;
      font-size: 14/$default-w+rem;
      .order_have {
        display: none;
      }
      .order_Phave {
        .payment_navtop {
          width: 100%;
          height: 20px;
          padding: 10px 0;
          line-height: 20px;
          background-color: $bgcolor;
          li {
            float: left;
            width: 25%;
            text-align: center;
          }
        }
        .payment_main {
          margin-top: 5px;
          background-color: white;
          .payment_main_goods {
            width: 100%;
            height: 100px;
            li {
              float: left;
              width: 25%;
              height: 100px;
              text-align: center;
              img {
                width: 90%;
                height: 92%;
                padding: 4% 5%;
              }
              p {
                margin-top: 25px;
                height: 50px;
                display: flex;
                align-items: center;
                span {
                  width: 100%;
                  text-align: center;
                }
              }
            }
          }
          .payment_main_Price {
            height: 25px;
            width: 100%;
            line-height: 25px;
            /*background-color: #8ec321;*/
            display: flex;
            justify-content: flex-end;
            span {
              display: inline-block;
              margin: 0 15px;
              label {
                color: $navcolor;
                font-size: 16px;
              }
            }
          }
          .payment_main_footer {
            height: 40px;
            width: 100%;
            background-color: white;
            border-top: 1px solid #ddd;
            display: flex;
            justify-content: flex-end;
            span {
              display: inline-block;
              text-align: center;
              height: 20px;
              margin-top: 8px;
              line-height: 20px;
              margin-right: 10px;
              padding: 1px 5px;
              border-radius: 25px;
              font-size: 14px;
              letter-spacing: $letter;
            }
            span:nth-child(1),
            span:nth-child(2) {
              border: 1px solid #7A7A7A;
              color: #7A7A7A;
            }
            span:nth-child(3) {
              color: $navcolor;
              border: 1px solid $navcolor;
            }
          }
        }
      }
      .order_no {
        display: none;
      }
      .order_pno {
        margin: 50px auto;
        width: 100%;
        line-height: 200px;
        display: flex;
        font-size: 14px;
        letter-spacing: 2px;
        justify-content: center;
        img {
          width: 100px;
          height: 200px;
        }
      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .order_payment {
      font-size: 14px;
      .order_have {
        .payment_navtop {
          margin-top: 2px;
          height: 40px;
          line-height: 40px;
          background-color: $bgcolor;
          li {
            float: left;
            width: 20%;
            text-align: center;
          }
        }
        .payment_main {
          margin-top: 1px;
          .payment_main_goods {
            margin-top: 5px;
            background-color: white;
            height: 110px;
            li {
              height: 110px;
              float: left;
              width: 20%;
              text-align: center;
              display: flex;
              justify-content: center;
              flex-direction: column;
              img {
                margin-top: 10px;
              }
              p {
                width: 100%;
                height: 50px;
                margin: 25px 0;
                display: flex;
                align-items: center;
                span {
                  width: 100%;
                  text-align: center;
                  /*background-color: #8ec321;*/
                }
              }
              .goodsBtn {
                width: 100%;
                height: 72px;
                button {
                  line-height: 24px;
                  width: 100%;
                  border: none;
                  background-color: white;
                  outline: none;
                }
              }
            }
          }
          .payment_main_footer {
            display: inline-block;
            padding: 10px 0;
            margin-top: 2px;
            width: 100%;
            height: 20px;
            line-height: 20px;
            background-color: $bgcolor;
            font-size: 14px;
            span {
              float: right;
              margin-right: 20px;
              label {
                color: $navcolor;
                font-size: 20px;
              }
            }
          }
        }
      }
      .order_Phave {
        display: none;
      }
      .order_no {
        margin: 0 auto;
        margin-top: 50px;
        height: 315px;
        width: 100%;
        line-height: 326px;
        display: flex;
        font-size: 18px;
        letter-spacing: 2px;
        justify-content: center;
        a {
          color: $navcolor;
        }
      }
      .order_pno {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/order_unpaid.vue